import React, { useEffect, useState } from 'react';
import { Image, Navbar, Nav, Dropdown, Row, Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import {
  HOME_FEED,
  MY_ROOM_ROUTE,
  NEXT_CHALLENGE_ROUTE,
  GUARDIAN_SETTINGS_ROUTE,
  LOGIN_ROUTE,
  CHALLENGE_ROUTE,
  SHARE_CREATION_ROUTE_BANNER,
  SPECIAL_CHALLENGE_ROUTE,
  EVENT_ROUTE,
  NOTIFICATION_ROUTE,
  TALETREE_MAP,
  KID_LOGIN_ROUTE,
  CAPTAIN_ROUTE,
  MULTI_LOGIN,
  HOME_FEED_GUARDIAN,
} from '../../constants/routes.constants';
import { useAuth } from '../auth/Auth';
import logo from '../../assets/logo/logo-53x53.svg';
import TaletreeHeader from './TaletreeHeader';
import ProfileMenu from './ProfileMenu';
import './css/camp.header.scss';
import letsgoProfile from '../../assets/profile/default-profile-letsgo.svg';
import { useHistory } from 'react-router-dom';
import { GUEST_LOGIN_ROUTE } from '../../constants/routes.constants';
import userAvtr from '../../assets/images/uni.svg';
import closeIcon from '../../assets/images/close.png';
import { changeBodyClassName, handleScrollToTop } from '../../utils/utils';
import { bg } from '../../constants/component.constants';
import Switch from 'react-switch';
import ImgMoon from '../../assets/icon/moon.svg';
import ImgSun from '../../assets/icon/sun.svg';
import Home from '../../assets/icon/header/Home.svg';
import HomeActive from '../../assets/icon/header/Home_active.svg';
import Challenge from '../../assets/icon/header/City.svg';
import ChallengeActive from '../../assets/icon/header/City_active.svg';
import Village from '../../assets/icon/header/Village.svg';
import VillageActive from '../../assets/icon/header/Village_active.svg';
import BackToDash from '../../assets/icon/back-to-dash.png';
import BackToDashDark from '../../assets/icon/back-to-dash-dark.png';
import MapMode from '../../assets/images/map-rocket.svg';
import MapModeHover from '../../assets/images/map-rocket-hover.svg';
import OptimizeSignup from '../views/onboarding/signup_popups/OptimizeSignup';
import Creative_Gallery from '../../assets/images/New_Change_Img/Creative.svg';
import Emrald_img from '../../assets/images/New_Change_Img/Emrald.svg';
import Villageimg from '../../assets/images/New_Change_Img/Village.svg';
import { isMobile } from 'react-device-detect';
import SwitchUser from '../../assets/icon/header/SwitchUser.png';
import activeSwitchUser from '../../assets/icon/header/activeSwitchUser.png';
import { multiLoginViewModal } from '../views/multilogin/multilogin.view.model';
import { getDependentUsernameFromLocalStorage } from '../../utils/local.storage.utils';

const CampHeader = ({
  isMyRoom = false,
  leftCollapsse = '',
  rightCollapsse = '',
}) => {
  const { logout, dependent, guardian, school, refreshUserState } = useAuth();
  const history = useHistory();
  const mode = localStorage.getItem('mode');
  const [checked, setChecked] = useState(mode === 'light' ? false : true);
  const [showModal, setShowModal] = useState(false);
  const [closeBlueBuble, setCloseBlueBuble] = useState(true);

  // setCloseBlueBuble(true)
  const gaurdianSignUp = () => {
    localStorage.setItem('kids_login_location', window.location.href);
    // history.push(GUEST_LOGIN_ROUTE);
    setShowModal(true);
  };

  const handleChange = (val) => {
    setChecked(val);
    if (val) {
      changeBodyClassName([bg.DARK]);
      localStorage.setItem('mode', 'dark');
    } else {
      changeBodyClassName([bg.CHALLENGES]);
      localStorage.setItem('mode', 'light');
    }
  };

  useEffect(() => {
    handleChange(mode === 'light' ? false : true);
  }, []);

  const handleGuestProfileClick = () => {
    const dependentDetails = JSON.parse(localStorage.getItem("dependentDetails"))
    if (dependentDetails) {
      history.push(`/${dependentDetails?.username}`)
    }else setShowModal(true);
  };
  const [isNavbarOpen, setIsNavbarOpen] = useState(false); // State to track if navbar is open

  const handleToggleClick = () => {
    setIsNavbarOpen(!isNavbarOpen); // Toggle navbar open state
  };

  useEffect(() => {
    if (isMobile) {
      if (
        leftCollapsse === 'left-collapsse' ||
        rightCollapsse === 'right-collapsse'
      ) {
        setIsNavbarOpen(true);
      } else {
        setIsNavbarOpen(false);
      }
    }
  }, [leftCollapsse, rightCollapsse]);

  const handleParentLogin = async () => {
    if (guardian?.id) {
      history.push(MULTI_LOGIN);
    } else {
      try {
        await multiLoginViewModal.multiLoginParent();
        localStorage.setItem('isGuardianFromBrowse', true);
        refreshUserState();
        history.push(MULTI_LOGIN);
      } catch (error) {
        console.log(error, 'error in  parent login ');
      }
    }
  };
  const checkUsernameInPathname = (users) => {
    const pathname = location.pathname;
    return users.some((user) => pathname === `/mytaletree/${user.username}`);
  };
  return (
    <TaletreeHeader className="camp-header kid">
      <div className="navbar-brand-wrapper">
        <LinkContainer to={HOME_FEED}>
          <Navbar.Brand>
            <Image src={logo} className="logo" />
          </Navbar.Brand>
        </LinkContainer>
        <div className="headerUserNotification">
          <Image src={userAvtr} className="User Avtar" />
          {school ? null : (
            <>
              {!guardian ? (
                <span className="userNotification">

                  <span onClick={() => setShowModal(true)}>
                    <u>Hello there, you are now in guest mode, click here to exit.</u>
                  </span>

                  {/* <span className="remove-pointer guest-text" >
                    Hello there, you are now in guest mode,
                  </span>{' '}
                  <span onClick={() => history.push(KID_LOGIN_ROUTE)}>
                    <u>click here to exit.</u>
                  </span> */}
                </span>
              ) : null}
            </>
          )}
          {!!guardian ? (
            <span className="userNotification">
              <span onClick={() => history.push(GUARDIAN_SETTINGS_ROUTE)}>
                <u>Hello there, you are now in guest mode, click here to exit.</u>
              </span>
              <Image onClick={() => setCloseBlueBuble(false)} src={closeIcon} className="guest_close_icon" />
            </span>
          ) : (
            ''
          )}
          {/* {guardian || school ? (
            ''
          ) : (
            // <span className='noti-header'>Hey {guardian !== null && guardian.first_name}, <span onClick={() => history.push(GUARDIAN_SETTINGS_ROUTE)}><u>click here to exit.</u></span></span>
            <Box className="noti-header">
              Hello there,{' '}
              <span onClick={() => history.push(KID_LOGIN_ROUTE)}>
                <u>click here to exit.</u>
              </span>
            </Box>
          )} */}
        </div>
      </div>
      {!isNavbarOpen && ( // Conditionally render based on navbar state
        <div className="mobile_marginTop_guest">
          <div className="col-12 text-center" onClick={handleScrollToTop}>
            <Image
              className="centerimghader"
              src={
                (history?.location?.pathname === HOME_FEED || history?.location?.pathname === HOME_FEED_GUARDIAN)
                  ? Creative_Gallery
                  : history.location.pathname === NEXT_CHALLENGE_ROUTE
                    ? Emrald_img
                    : isMyRoom ||
                      history.location.pathname.slice(0, 8) === CAPTAIN_ROUTE
                      ? Villageimg
                      : ''
              }
              alt=""
            />
          </div>
        </div>
      )}
      <Navbar.Toggle
        aria-controls="basic-navbar-nav"
        onClick={handleToggleClick}
      />
      <Navbar.Collapse
        id="responsive-navbar-nav"
        className="justify-content-end"
      >
        <Nav className="ml-auto align-items-md-center navbar-sub navbar-custom">
          <LinkContainer
            to={
              guardian?.viewer === 'guardian' ? HOME_FEED_GUARDIAN : HOME_FEED
            }
          >
            <Nav.Link
              className={`px-3 camp-header-link Home-feed-header ${history?.location?.pathname ===
                (HOME_FEED_GUARDIAN || HOME_FEED)
                ? 'header-active'
                : ''
                }`}
            >
              <Image
                className="guest_header_icon_size_img home-normal-state"
                src={
                  history?.location?.pathname ===
                    (HOME_FEED_GUARDIAN || HOME_FEED)
                    ? HomeActive
                    : Home
                }
                alt=""
              />
              <Image
                className="guest_header_icon_size_img home-hover-state"
                src={HomeActive}
                alt=""
              />
              <span className="mob-menu">Creative Gallery</span>
            </Nav.Link>
          </LinkContainer>
          <LinkContainer to={NEXT_CHALLENGE_ROUTE}>
            <Nav.Link
              className={`px-3 camp-header-link City-header ${history.location.pathname.slice(0, 11) ===
                NEXT_CHALLENGE_ROUTE ||
                history.location.pathname.slice(0, 10) === CHALLENGE_ROUTE
                ? 'header-active'
                : ''
                }`}
            >
              {history.location.pathname.slice(0, 11) ===
                NEXT_CHALLENGE_ROUTE ||
                history.location.pathname.slice(0, 10) === CHALLENGE_ROUTE ||
                history.location.pathname.slice(0, 18) ===
                SPECIAL_CHALLENGE_ROUTE ||
                history.location.pathname.slice(0, 6) === EVENT_ROUTE ? (
                <Image
                  className="guest_header_icon_size_img"
                  src={ChallengeActive}
                  alt=""
                />
              ) : (
                <>
                  <Image
                    className="guest_header_icon_size_img city-normal-state"
                    src={Challenge}
                    alt=""
                  />
                  <Image
                    className="guest_header_icon_size_img city-hover-state"
                    src={ChallengeActive}
                    alt=""
                  />
                </>
              )}
              <span className="mob-menu">Emerald City</span>
            </Nav.Link>
          </LinkContainer>
          {!guardian && !dependent ? (
            // <LinkContainer to={LOGIN_ROUTE}>
            <Nav.Link
              className="px-3 camp-header-link Village-header"
              onClick={handleGuestProfileClick}
            >
              {history.location.pathname.slice(0, 11) !==
                NEXT_CHALLENGE_ROUTE &&
                history.location.pathname.slice(0, 10) !== CHALLENGE_ROUTE &&
                history.location.pathname.slice(0, 18) !==
                SPECIAL_CHALLENGE_ROUTE &&
                history.location.pathname.slice(0, 6) !== EVENT_ROUTE &&
                history.location.pathname !== HOME_FEED ? (
                <Image
                  className="guest_header_icon_size_img"
                  src={VillageActive}
                  alt=""
                />
              ) : (
                <>
                  <Image
                    className="guest_header_icon_size_img village-normal-state"
                    src={Village}
                    alt=""
                  />
                  <Image
                    className="guest_header_icon_size_img village-hover-state"
                    src={VillageActive}
                    alt=""
                  />
                </>
              )}
              <span className="mob-menu">TaleTree Village</span>
            </Nav.Link>
          ) : (
            // </LinkContainer>
            <LinkContainer
              to={
                localStorage.getItem('set_dependent')
                  ?`/${localStorage.getItem('set_dependent')}`
                  : `/${localStorage.getItem('selected_dependent')}`
              }
            >
              <Nav.Link
                className={`px-3 camp-header-link Village-header ${history.location.pathname.slice(0, 11) !==
                  NEXT_CHALLENGE_ROUTE &&
                  history.location.pathname !== HOME_FEED &&
                  history.location.pathname.slice(0, 10) !== CHALLENGE_ROUTE &&
                  history.location.pathname.slice(0, 18) !==
                  SPECIAL_CHALLENGE_ROUTE &&
                  history.location.pathname.slice(0, 6) !== EVENT_ROUTE &&
                  history.location.pathname.slice(0, 9) !==
                  SHARE_CREATION_ROUTE_BANNER &&
                  history.location.pathname !== NOTIFICATION_ROUTE
                  ? 'header-active'
                  : ''
                  }`}
              >
                {history.location.pathname.slice(0, 11) !==
                  NEXT_CHALLENGE_ROUTE &&
                  history.location.pathname !== HOME_FEED &&
                  history.location.pathname.slice(0, 10) !== CHALLENGE_ROUTE &&
                  history.location.pathname.slice(0, 18) !==
                  SPECIAL_CHALLENGE_ROUTE &&
                  history.location.pathname.slice(0, 6) !== EVENT_ROUTE &&
                  history.location.pathname.slice(0, 9) !==
                  SHARE_CREATION_ROUTE_BANNER &&
                  history.location.pathname !== NOTIFICATION_ROUTE ? (
                  <Image
                    className="guest_header_icon_size_img"
                    src={VillageActive}
                    alt=""
                  />
                ) : (
                  <>
                    <Image
                      className="guest_header_icon_size_img village-normal-state"
                      src={Village}
                      alt=""
                    />
                    <Image
                      className="guest_header_icon_size_img village-hover-state"
                      src={VillageActive}
                      alt=""
                    />
                  </>
                )}
                <span className="mob-menu">TaleTree Village</span>
              </Nav.Link>
            </LinkContainer>
          )}
          {dependent?.viewer === 'guardian' ||
            guardian?.viewer === 'guardian' ? (
            <Nav.Link
              onClick={() => handleParentLogin()}
              className={`px-3 camp-header-link Home-feed-header mob-menu`}
            >
              <Image
                className="fit_size_img"
                src={
                  history?.location?.pathname === HOME_FEED
                    ? SwitchUser
                    : activeSwitchUser
                }
                alt=""
                style={{
                  height: '40px',
                  paddingLeft: 0,
                }}
              />
              <span className="mob-menu">Switch Account</span>
            </Nav.Link>
          ) : (
            ''
          )}
          {guardian && (
            <LinkContainer to={GUARDIAN_SETTINGS_ROUTE}>
              <Nav.Link className={`px-3 camp-header-link mob-menu`}>
                <Image
                  className="mob-menu"
                  style={{ marginLeft: '-5px', maxWidth: '30px' }}
                  src={mode === 'dark' ? BackToDash : BackToDashDark}
                  alt=""
                />
                <span className="mob-menu">Back to dashboard</span>
              </Nav.Link>
            </LinkContainer>
          )}
          <Dropdown className="profile-menu-header-container">
            <div
              className="map-mode"
              onClick={() => history.push(TALETREE_MAP)}
            >
              <img className="normal-state" src={MapMode} alt="" />
              <img className="hover-state" src={MapModeHover} alt="" />
            </div>
            <label htmlFor="small-radius-switch">
              <Switch
                checked={checked}
                onChange={handleChange}
                handleDiameter={28}
                offColor="#08f"
                onColor="#101B2F"
                offborder="2px solid #CCDCF3"
                // onBorder="2px solid #CCDCF3"
                height={50}
                width={120}
                borderRadius={150}
                activeBoxShadow="0px 0px 1px 2px #fffc35"
                uncheckedIcon={
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '100%',
                      fontSize: 9,
                      color: '#fff',
                      paddingRight: 2,
                      paddingLeft: 1,
                      fontWeight: 700,
                      textTransform: 'uppercase',
                      fontFamily: 'Open Sans',
                    }}
                  >
                    Day Mode
                  </div>
                }
                checkedIcon={
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '100%',
                      fontSize: 9,
                      color: '#fff',
                      paddingRight: 2,
                      paddingLeft: 1,
                      fontWeight: 700,
                      textTransform: 'uppercase',
                      fontFamily: 'Open Sans',
                    }}
                  >
                    Night Mode
                  </div>
                }
                uncheckedHandleIcon={
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '100%',
                    }}
                  >
                    <img src={ImgSun} />
                  </div>
                }
                checkedHandleIcon={
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '100%',
                    }}
                  >
                    <img src={ImgMoon} />
                  </div>
                }
                className="react-switch"
                id="small-radius-switch"
              />
            </label>
            {guardian || school ? (
              <ProfileMenu />
            ) : (
              <Dropdown.Toggle
                className="rounded-pill avatar-button"
                id="dropdown-basic"
              >
                <div className="avatar-wrapper">
                  <div className="simple-type" onClick={gaurdianSignUp}>
                    <Image className="rounded-circle" src={letsgoProfile} />
                    Guest
                  </div>
                </div>
              </Dropdown.Toggle>
            )}
            {/* <Dropdown.Menu className="profile-menu-header dropdown-menu-right">
              <Row className="align-items-center profile-menu-item">
                <Col className="profile-menu-action-text">
                  <RoundButton
                    label="Log out"
                    type="button"
                    className="logout-button"
                    onClick={() => logout()}
                  />
                </Col>
              </Row>
            </Dropdown.Menu> */}
          </Dropdown>
          <div className="mobile-search">
            {/* <Search /> */}
            <div className="mobile-bottom-wrapper">
              <div
                className="map-mode"
                onClick={() => history.push(TALETREE_MAP)}
              >
                <img className="normal-state" src={MapMode} alt="" />
                <img className="hover-state" src={MapModeHover} alt="" />
              </div>
              <label htmlFor="small-radius-switch">
                <Switch
                  checked={checked}
                  onChange={handleChange}
                  handleDiameter={28}
                  offColor="#08f"
                  onColor="#101B2F"
                  offborder="2px solid #CCDCF3"
                  // onBorder="2px solid #CCDCF3"
                  height={50}
                  width={120}
                  borderRadius={150}
                  activeBoxShadow="0px 0px 1px 2px #fffc35"
                  uncheckedIcon={
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        fontSize: 9,
                        color: '#fff',
                        paddingRight: 2,
                        paddingLeft: 1,
                        fontWeight: 700,
                        textTransform: 'uppercase',
                        fontFamily: 'Open Sans',
                      }}
                    >
                      Day Mode
                    </div>
                  }
                  checkedIcon={
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        fontSize: 9,
                        color: '#fff',
                        paddingRight: 2,
                        paddingLeft: 1,
                        fontWeight: 700,
                        textTransform: 'uppercase',
                        fontFamily: 'Open Sans',
                      }}
                    >
                      Night Mode
                    </div>
                  }
                  uncheckedHandleIcon={
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                      }}
                    >
                      <img src={ImgSun} />
                    </div>
                  }
                  checkedHandleIcon={
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                      }}
                    >
                      <img src={ImgMoon} />
                    </div>
                  }
                  className="react-switch"
                  id="small-radius-switch"
                />
              </label>
            </div>
          </div>
        </Nav>
      </Navbar.Collapse>
      <OptimizeSignup showModal={showModal} setShowModal={setShowModal} />
    </TaletreeHeader>
  );
};

export default CampHeader;
